import { ChakraBox } from '@equip.health/ui';
import { useEditNoteDrawerContext } from '~/lib/contexts/EditNoteDrawerContext';
import { EditNoteDrawerForm } from './EditNoteDrawerForm';

export const EditNoteDrawerPortal = () => {
  const { drawerStatus } = useEditNoteDrawerContext();

  const isOpen = drawerStatus === 'open';
  const wrapperZIndex = isOpen ? 101 : 1;

  return (
    <ChakraBox zIndex={wrapperZIndex}>
      <EditNoteDrawerForm />
    </ChakraBox>
  );
};
